import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterWrapper = styled.footer`
  background: var(--ec-footer-bg);
  color: #fff;
  padding: 60px 50px 0;

  @media screen and (max-width: 768px) {
    padding: 40px 30px 0;
  }
`;

export const FooterInner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`;

export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr;
  gap: 40px;
  padding-bottom: 40px;

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BrandCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const BrandLogo = styled.img`
  height: 36px;
  width: auto;
  object-fit: contain;
  align-self: flex-start;

  @media screen and (max-width: 600px) {
    align-self: center;
  }
`;

export const BrandDesc = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
  margin: 0;
  max-width: 280px;

  @media screen and (max-width: 600px) {
    text-align: center;
    max-width: 100%;
  }
`;

export const SocialRow = styled.div`
  display: flex;
  gap: 16px;

  @media screen and (max-width: 600px) {
    justify-content: center;
  }
`;

export const SocialIcon = styled.a`
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

export const FooterCol = styled.div``;

export const FooterColTitle = styled.h4`
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: #fff;
  margin: 0 0 16px;
`;

export const FooterLink = styled(Link)`
  display: block;
  font-family: "Nunito", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

export const ExternalLink = styled.a`
  display: block;
  font-family: "Nunito", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }
`;

export const AppCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AppBadge = styled.a`
  display: inline-block;
  text-decoration: none;
  width: fit-content;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  img {
    height: 44px;
    width: auto;
    object-fit: contain;
    display: block;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
    text-align: center;
  }
`;

export const Copyright = styled.span`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);

  @media screen and (max-width: 768px) {
    justify-self: center;
  }
`;

export const Disclaimer = styled.span`
  font-family: "Nunito", sans-serif;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  text-align: center;
  justify-self: center;
  line-height: 1.5;

  strong {
    color: #fff;
    font-weight: 700;
  }

  @media screen and (max-width: 768px) {
    justify-self: center;
  }
`;

export const LegalLinks = styled.div`
  display: flex;
  gap: 20px;
  justify-self: end;

  @media screen and (max-width: 768px) {
    justify-self: center;
    justify-content: center;
  }
`;

export const LegalLink = styled.span`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #fff;
  }
`;
